import { _formatCourse, _formatCourses } from '../../helpers'

const userActiveCourses = state => _formatCourses(state.userActiveCourses)
const bookmarksByCourse = state =>
  state.bookmarksByCourse.map(bookmark => {
    const course = _formatCourse(bookmark.course.data)
    return { ...bookmark, course }
  })
const pendingBookmark = state => state.pendingBookmark
const allProgress = state => state.allProgress
const progress = state => state.progress
const pathProgress = state => state.pathProgress
const pathResume = state => state.pathResume
const activeSubscriptions = state => state.activeSubscriptions
const sampleAvatars = state => state.sampleAvatars
const currentAvatar = state => state.currentAvatar

export default {
  bookmarksByCourse,
  userActiveCourses,
  pendingBookmark,
  allProgress,
  progress,
  pathProgress,
  pathResume,
  activeSubscriptions,
  sampleAvatars,
  currentAvatar,
}
